<template>
  <div class="mx-auto">
    <v-skeleton-loader
      :loading="loading"
      :type="type"
      tile
      :dark="$vuetify.theme.isDark">
      <div>
        <slot name="default"></slot>
      </div>
    </v-skeleton-loader>
  </div>
</template>

<script>
const props = {
  loading: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: false,
    default: 'image'
  }
}

export default {
  name: 'SkeletonLoader',
  props
}
</script>

<style>
.v-skeleton-loader--is-loading {
  margin-bottom: 5px;
}

.theme--light.v-skeleton-loader .v-skeleton-loader__actions,
.theme--light.v-skeleton-loader .v-skeleton-loader__article,
.theme--light.v-skeleton-loader .v-skeleton-loader__card-heading,
.theme--light.v-skeleton-loader .v-skeleton-loader__card-text,
.theme--light.v-skeleton-loader .v-skeleton-loader__date-picker,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-text,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-two-line,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-three-line,
.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line,
.theme--light.v-skeleton-loader .v-skeleton-loader__table-heading,
.theme--light.v-skeleton-loader .v-skeleton-loader__table-thead,
.theme--light.v-skeleton-loader .v-skeleton-loader__table-tbody,
.theme--light.v-skeleton-loader .v-skeleton-loader__table-tfoot {
  background: transparent;
}
</style>
